import React, { useState } from 'react';

interface Doc { id:number; name:string; type:string; size:string; date:string; category:string; }
const DOCS: Doc[] = [
  {id:1,name:'AUD-2026-001 — ABC Logistics Audit Shield.pdf',type:'PDF',size:'142 KB',date:'2026-04-13',category:'Audit Shield'},
  {id:2,name:'AUD-2026-002 — Johnson Home Audit Shield.pdf',type:'PDF',size:'138 KB',date:'2026-04-13',category:'Audit Shield'},
  {id:3,name:'Rivera Family — Whole Life Policy.pdf',type:'PDF',size:'2.1 MB',date:'2026-04-11',category:'Policy'},
  {id:4,name:'ABC Logistics — Commercial Auto Application.pdf',type:'PDF',size:'856 KB',date:'2026-04-10',category:'Application'},
  {id:5,name:'Q1 2026 Compliance Report.pdf',type:'PDF',size:'412 KB',date:'2026-04-01',category:'Report'},
  {id:6,name:'Southeast Catering — GL Quote.pdf',type:'PDF',size:'234 KB',date:'2026-04-08',category:'Quote'},
];
const catColors: Record<string,string> = {'Audit Shield':'bg-blue-100 text-blue-700','Policy':'bg-green-100 text-green-700','Application':'bg-purple-100 text-purple-700','Report':'bg-orange-100 text-orange-700','Quote':'bg-yellow-100 text-yellow-700'};

const DocumentManager: React.FC = () => {
  const [docs, setDocs] = useState<Doc[]>(DOCS);
  const [search, setSearch] = useState('');
  const [cat, setCat] = useState('All');
  const cats = ['All',...Array.from(new Set(DOCS.map(d=>d.category)))];
  const filtered = docs.filter(d=>(cat==='All'||d.category===cat)&&d.name.toLowerCase().includes(search.toLowerCase()));

  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between">
        <h1 className="text-2xl font-bold text-gray-900">Documents ({filtered.length})</h1>
        <div className="flex gap-2">
          <span className="px-3 py-2 text-sm text-gray-500 bg-gray-100 rounded-lg">{docs.filter(d=>d.category==='Audit Shield').length} Audit Shield™</span>
        </div>
      </div>
      <div className="flex flex-col sm:flex-row gap-3">
        <input value={search} onChange={e=>setSearch(e.target.value)} placeholder="Search documents..." className="flex-1 px-4 py-2 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-blue-500" />
        <select value={cat} onChange={e=>setCat(e.target.value)} className="px-3 py-2 border border-gray-300 rounded-lg text-sm">
          {cats.map(c=><option key={c}>{c}</option>)}
        </select>
      </div>
      <div className="bg-white rounded-xl border border-gray-200 overflow-hidden">
        <table className="w-full text-sm">
          <thead className="bg-gray-50 border-b border-gray-200">
            <tr>{['Document','Category','Size','Date',''].map(h=><th key={h} className="px-4 py-3 text-left text-xs font-semibold text-gray-500 uppercase">{h}</th>)}</tr>
          </thead>
          <tbody className="divide-y divide-gray-100">
            {filtered.map(d=>(
              <tr key={d.id} className="hover:bg-gray-50">
                <td className="px-4 py-3">
                  <div className="flex items-center gap-2">
                    <svg className="w-4 h-4 text-red-500 flex-shrink-0" fill="currentColor" viewBox="0 0 24 24"><path d="M14 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V8l-6-6z"/></svg>
                    <span className="font-medium text-gray-900 truncate max-w-xs">{d.name}</span>
                  </div>
                </td>
                <td className="px-4 py-3"><span className={`px-2 py-0.5 rounded-full text-xs font-medium ${catColors[d.category]||'bg-gray-100 text-gray-600'}`}>{d.category}</span></td>
                <td className="px-4 py-3 text-gray-500">{d.size}</td>
                <td className="px-4 py-3 text-gray-500">{d.date}</td>
                <td className="px-4 py-3 flex gap-2">
                  <button className="text-xs text-blue-600 hover:text-blue-800">Download</button>
                  <button onClick={()=>setDocs(p=>p.filter(x=>x.id!==d.id))} className="text-xs text-red-500 hover:text-red-700">Delete</button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};
export default DocumentManager;
